@let isSuccessStep = stepper().selectedIndex === stepper().steps.length - 1;

<mat-stepper
  [linear]="isLinear()"
  (selectedIndexChange)="onSelectedIndexChange()"
  [disableRipple]="isSuccessStep"
  [class.success]="isSuccessStep"
>
  @for (step of config().items; track step) {
    @let stepControl = getStepControl(step);

    <ui-mat-step-extended [stepControl]="stepControl" [editable]="!isSuccessStep">
      @if (step.title) {
        <ng-template matStepLabel>{{ step.title }}</ng-template>
      }

      @if (step.description) {
        <p>{{ step.description }}</p>
      }

      @if (currentStep() === step) {
        <form [formGroup]="stepControl" [data]="step" uiFormConditionalFields (ngSubmit)="onStepSubmit($event)">
          <ui-form-step [data]="step" [hideTitle]="hideTitle" [control]="stepControl"></ui-form-step>

          @if (data.buttonLabels; as buttonLabels) {
            <div class="form-actions">
              @let previousLabel = buttonLabels.previous;
              @if (!$first && !$last && previousLabel) {
                <ui-button type="button" buttonStyle="outlined" (click)="onPreviousClick()">
                  {{ previousLabel }}
                </ui-button>
              }

              @let nextLabel = $last ? buttonLabels.done : buttonLabels.next;
              @if (nextLabel) {
                <ui-button type="submit" buttonStyle="filled" (click)="onNextClick()" [loading]="isLoading()">
                  {{ nextLabel }}
                </ui-button>
              }
            </div>
          }
        </form>
      }
    </ui-mat-step-extended>
  }

  <ng-template matStepperIcon="edit">
    <ui-icon faStyle="solid" faName="pen"></ui-icon>
  </ng-template>

  <ng-template matStepperIcon="done" let-index="index">
    <ui-icon faStyle="solid" [faName]="stepNumberIcons[index]"></ui-icon>
  </ng-template>

  <ng-template matStepperIcon="number" let-index="index">
    <ui-icon faStyle="solid" [faName]="stepNumberIcons[index]"></ui-icon>
  </ng-template>
</mat-stepper>
